/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC } from 'react';

import { CircularProgress } from '@material-ui/core';

export const OAuthInProgress: FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <p>Авторизация в процессе, пожалуйста подождите...</p>
      <CircularProgress />
    </div>
  );
};
